import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      {/* Desktop sticky top bar */}
      <AnimatePresence data-id="element-167">
        {isVisible && <motion.div initial={{
        y: -100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -100,
        opacity: 0
      }} className="fixed top-0 left-0 right-0 z-50 bg-navy shadow-lg border-b border-gold/30 hidden md:block" data-id="element-168">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between" data-id="element-169">
              <span className="text-white font-heading font-bold text-base tracking-wide" data-id="element-170">
                El Código del Crédito 750+
              </span>
              <button onClick={scrollToPricing} className="bg-gold hover:bg-gold-light text-navy-dark font-bold py-2 px-5 rounded-full transition-colors duration-300 flex items-center gap-2 text-sm" data-id="element-171">
                QUIERO MI CÓDIGO
                <ArrowRightIcon className="w-4 h-4" data-id="element-172" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}